import { ISearchParams, IResidence } from 'interfaces'
import { Key, useCallback, useEffect, useState } from 'react'
import { residenceService } from 'services'

function useResidence(strutturaId: Key, searchParams?: ISearchParams, setError?: (error: any) => void) {
  const [residence, setResidence] = useState<IResidence>()
  const [loading, setLoading] = useState<boolean>(false)

  const setResult = useCallback((result: IResidence) => {
    setResidence(result)
    setLoading(false)
  }, [])
  const setErrorResult = useCallback((error: any) => {
    setLoading(false)
    !!setError && setError(error)
  }, [])

  useEffect(() => {
    setLoading(true)
    const token = residenceService.getResidence(strutturaId, setResult, setErrorResult, searchParams)
    return () => {
      token?.abort()
      setLoading(false)
    }
  }, [strutturaId, searchParams, setError])

  return { residence, loading }
}

export default useResidence
